import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchReportJobs({ payload }) {
  const { page = 1, limit = 10, filters = {} } = payload || {};
  
  try {
    const res = yield call(API.getReportJobs, { page, limit, filters });
    const responseData = res?.data?.data;
    
    if (responseData) {
      yield put(
        actions.fetchReportJobsSuccess({
          jobs: responseData.jobs || [],
          pagination: responseData.pagination || {
            page: 1,
            limit: 10,
            total: 0,
            pages: 1,
          },
        })
      );
    } else {
      yield put(
        actions.fetchReportJobsFailure("Invalid response from server")
      );
    }
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.message ||
      "Failed to fetch report jobs";
    yield put(actions.fetchReportJobsFailure(message));
  }
}

export function* reportJobsSaga() {
  yield takeLatest(actions.fetchReportJobs.type, handleFetchReportJobs);
}